function autoLoad( container ) {
    container.querySelectorAll( '[data-autoload-url]' ).forEach( function( el ) {
        var loaded = el.dataset.autoloadLoaded;

        if ( loaded ) {
            return;
        }

        el.dataset.autoloadLoaded = true;
        var url = el.dataset.autoloadUrl;

        var resetHeight = false;

        if ( el.dataset.resetHeight && el.dataset.resetHeight === 'true' ) {
            resetHeight = true;
        }

        http( url )
            .then( function( response ) {
                return response.text();
            } )
            .then( function( html ) {
                if ( !html ) {
                    el.remove();
                    return;
                }

                var range = document.createRange();
                range.selectNode( el );
                el.appendChild( range.createContextualFragment( html ) );

                document.dispatchEvent( new CustomEvent( 'twc:newcontentloaded', {
                    detail: {
                        container: el,
                    },
                    bubbles: true,
                } ) );

                if ( resetHeight ) {
                    el.style[ 'min-height' ] = 'auto';
                }
            } );
    } );
}

export default autoLoad;
